import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-white" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1B5E20] rounded-3xl p-8 md:p-16 text-center text-white relative overflow-hidden" data-id="element-76">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-77" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-78" />

          <div className="relative z-10" data-id="element-79">
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-8 backdrop-blur-sm" data-id="element-80">
              <ShieldCheck className="w-10 h-10 text-[#10B981]" data-id="element-81" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-82">
              90-Day "Feel Like You Again" Guarantee
            </h2>

            <div className="space-y-6 text-lg text-gray-200 max-w-2xl mx-auto mb-8" data-id="element-83">
              <p data-id="element-84">Try LymphoriaX™ for 90 days.</p>
              <p data-id="element-85">If you don't feel:</p>
              <div className="flex flex-wrap justify-center gap-4 font-bold text-white" data-id="element-86">
                <span data-id="element-87">✓ less puffy</span>
                <span data-id="element-88">✓ lighter</span>
                <span data-id="element-89">✓ more comfortable in your body</span>
              </div>
              <p data-id="element-90">You get a full refund.</p>
              <p className="font-bold" data-id="element-91">No stress. No forms. No questions.</p>
              <p className="text-[#10B981] font-bold text-xl" data-id="element-92">
                That's how confident we are.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}